import React from "react";
import { Button } from "reactstrap";
import classnames from "classnames";
import style from "./Fields.module.scss";

const LocalINTL = ({ isLocal, oneSide, onChange, ...props }) => {
  const { readonly } = props;

  if (readonly || oneSide) {
    return <ReadOnly isLocal={!!isLocal} />;
  }

  return (
    <div className={style.localINTL}>
      <Button
        onClick={() => onChange({ Local: true })}
        className={classnames(style.local, !isLocal ? "" : style.off)}
        disabled={!!isLocal}
      >
        Local
      </Button>

      <Button
        onClick={() => onChange({ Local: false })}
        className={classnames(style.INTL, isLocal ? "" : style.off)}
        disabled={!!isLocal == false}
      >
        INTL
      </Button>
    </div>
  );
};

const ReadOnly = ({ isLocal }) => <div className={style.localINTLRO}>{isLocal ? "Local" : "INTL"}</div>;

export default LocalINTL;
